package ui.eReceipt

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.clearAndSetSemantics
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.unit.dp
import receipt.OriginType
import receipt.hasFlags
import ui.Colors.Companion.SimpleEreceiptBackground
import ui.eReceipt.components.PerforatedEdgeContainer
import ui.eReceipt.receiptTypes.DefaultReceipt
import ui.eReceipt.receiptTypes.DejavooReceipt

@Composable
fun SimplifiedEReceiptScreen(
    viewModel: EReceiptViewModel = eReceiptViewModel()
) {
    val eReceiptStateFlow = viewModel.eReceiptStateFlow
    val scrollState = rememberScrollState()
    val maxWidth = eReceiptMaxWidth
    SelectionContainer {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .background(SimpleEreceiptBackground)
                .padding(top = 8.dp)
                .verticalScroll(scrollState),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            val _eReceipt by eReceiptStateFlow.collectAsState()
            val eReceipt = _eReceipt

            if (eReceipt != null) {
                PerforatedEdgeContainer(maxWidth) {
                    when {
                        eReceipt.originType.hasFlags(OriginType.Dejavoo, OriginType.SDK_API) -> {
                            DejavooReceipt(
                                maxWidth = maxWidth,
                                eReceipt = eReceipt,
                                merchantInformationStateFlow = null,
                                loggedInCustomerIdMatchesReceiptCustomerId = false,
                                isSimplified = true
                            )
                        }

                        else -> {
                            DefaultReceipt(
                                maxWidth = maxWidth,
                                eReceipt = eReceipt,
                                merchantInformationStateFlow = null,
                                loggedInCustomerIdMatchesReceiptCustomerId = false,
                                isSimplified = true
                            )
                        }
                    }
                }
            } else {
                CircularProgressIndicator(
                    modifier = Modifier
                        .align(Alignment.CenterHorizontally)
                        .clearAndSetSemantics {
                            contentDescription = "Loading eReceipt"
                        }
                )
            }
        }
    }
}